export default "__VITE_ASSET__BCGfOj5h__"